import { Link } from "react-router-dom";
import { Globe, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "../data/site";

const COLS = [
  {
    title: "Products",
    links: [
      ["Pallet Racking", "/products/pallet-racking-system"],
      ["Shelving Systems", "/products/single-tier-shelving-system"],
      ["Slotted Angle Racks", "/products/slotted-angle-racks"],
      ["Mezzanine Systems", "/products/mezzanine-system"],
      ["Cantilever Racking", "/products/cantilever-racking"],
      ["Storage Pallets", "/products/steel-pallets"],
    ],
  },
  {
    title: "Services",
    links: [
      ["Layout & Design", "/services"],
      ["Supply & Installation", "/services"],
      ["Dismantling & Reinstallation", "/services"],
      ["Rack Audit", "/services"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/about"],
      ["Solutions", "/solutions"],
      ["Services", "/services"],
      ["Contact", "/contact"],
    ],
  },
];

export function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo-chip" data-testid="footer-logo">
              <img src="/assets/custoracks-logo.png" alt="CustoRacks — Customised Storage Solutions" />
            </Link>
            <p>Customised warehouse and industrial storage solutions — from racking and shelving to mezzanine systems, pallets and rack safety accessories. From layout planning and design to supply and installation.</p>
          </div>
          {COLS.map((col) => (
            <div className="footer-col" key={col.title}>
              <h4>{col.title}</h4>
              {col.links.map(([label, to]) => (
                <Link key={label} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{label}</Link>
              ))}
            </div>
          ))}
          <div className="footer-col">
            <h4>Contact</h4>
            <a className="footer-contact-item" href={CONTACT.phoneHref} data-testid="footer-phone"><Phone size={15} /> {CONTACT.phoneDisplay}</a>
            <a className="footer-contact-item" href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="footer-whatsapp"><MessageCircle size={15} /> WhatsApp Us</a>
            <a className="footer-contact-item" href={`mailto:${CONTACT.email}`} data-testid="footer-email"><Mail size={15} /> {CONTACT.email}</a>
            <span className="footer-contact-item"><MapPin size={15} /> {CONTACT.address}</span>
            <span className="footer-contact-item"><Globe size={15} /> {CONTACT.website}</span>
          </div>
        </div>
        <div className="footer-bottom">
          <span data-testid="footer-copy">© 2026 CustoRacks. All Rights Reserved.</span>
          <span>
            <Link to="/privacy-policy" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms">Terms & Conditions</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
